import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Location } from '@angular/common';
import { ModalController } from '@ionic/angular';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { EditorList, EditorListDetails } from './editor.interface';
import { BackendCallService } from 'src/app/services/backend-call/backend-call.service';
import { UserAuthService } from 'src/app/services/user-auth/user-auth.service';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ShareValuesService } from 'src/app/services/sharedValues/share-values.service';
import { AppConstants, Froala_Constants, availableLngs, urlPathConstants } from 'src/app/utilities/constant';
import { ToastService } from 'src/app/services/toast.service';
import { ConfirmationModalComponent } from 'src/app/components/confirmation-modal/confirmation-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { bindFroalaListIndentFix, handleFroalaListBackspace, handleFroalaListIndentCommand, registerFroalaListIndentCommand } from 'src/app/utilities/froala-list-indent-command';
import { applyFroalaTableBorderStyleToSelection, applyFroalaTableCellStyleToSelection, applyFroalaTableVerticalAlignToSelection, bindFroalaTableSelectionHandlers, handleFroalaTableMouseDown, normalizeFroalaTableVerticalAlignCells, rememberCurrentFroalaTableCells, registerFroalaTableBorderCommand } from 'src/app/utilities/froala-table-border-command';
declare let FroalaEditor: any;
  
@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss'],
})
export class EditorComponent implements OnInit {
  private readonly froalaLanguageMap: Record<string, string> = {
    da: 'da',
    de: 'de',
    en: 'en_us',
    fr: 'fr',
    it: 'it',
    ko: 'ko',
    nl: 'nl',
    pl: 'pl',
    pt: 'pt_pt',
    sp: 'es',
    sv: 'sv',
    th: 'th',
    tr: 'tr',
    vi: 'vi',
    zh: 'zh_cn',
  };

  templateForm: FormGroup;
  @Input() templateTypes: any;
  @Input() templateData: any;
  @Input() title: any;
  @Output() exitEvent = new EventEmitter<void>();
  @Input() editorClass : string;
  public languages = availableLngs.map(language => ({
    label: language.title,
    value: language.val,
  }));
  newPages: { page_id: any, page_no: any, static_content: string }[] = [];
  pageIdCounter: number = 1;
  activePageIndex: number = 0;
  froalaEditors: any[] = [];
  pageContents: string[] = [];
  editorIds: string[] = [];
  editorContent: EditorList = [];
  isActive= true;
  userInfo: {
    name: string; userId: string; email: string; jobTitle: string; isGlobalAdmin: boolean; profileData: {}; permissions: any[]; // this.initailizeFroala();
  };
  @ViewChild('TemplateForm') form: NgForm;
  templateName: any
  selectedLangauge: any;
  static_content_string: any;
  isSaveEnabled: boolean = false;
  editorInstances = {};
  hasEditorContent: boolean;
  templateId: any;
  static_template_pages_id: string;
  editorCounter: number = 1;
  currentEditor;
  currentPageNo;
  public saveTemplateResponse: any;
  allowTyping: boolean;
  @ViewChildren('froalaEditorDiv') editorDivs!: QueryList<ElementRef>;
  pageEditorId: any;
  constructor(private backendService: BackendCallService,
    public userAuthService: UserAuthService,
    private fb: FormBuilder,
    public sharedValue: ShareValuesService,
    public location: Location,
    private toastService: ToastService,
    public modalController: ModalController,
    private cdr: ChangeDetectorRef,
    public translate: TranslateService, 
    ) {
      registerFroalaListIndentCommand();
      registerFroalaTableBorderCommand();
    }

  ngOnInit() {
    // To hide the exit button on editor component that navigate back to library page
    this.sharedValue.showExitOnEditorTemplate = false;
    this.templateForm = this.fb.group({
      name: ['', [Validators.required]],
      langauge: ['', [Validators.required]],
      editorsData: this.fb.array(this.editorIds.map(() => ['', Validators.required]))
    });
    this.userInfo = this.userAuthService.getUserList();
    setTimeout(() => {
      if (this.templateData) {
        this.templateName = this.templateData?.file_name;
        this.selectedLangauge = this.templateData?.language;
        this.templateId = this.templateData?.id;
        if(!this.templateData?.static_content_string) {
          this.addNewPage();
        }
      }
    }, 200);
    if (this.templateData && this.templateData?.static_content_string != '' 
        || this.templateData?.static_content_string != undefined) {
      let parsedContent = JSON.parse(JSON.stringify(this.templateData?.static_content_string));
      console.log("parsedContent", parsedContent)
      this.static_content_string = JSON.parse(parsedContent?.split());
      this.static_content_string.map((item) => {
        item.is_active = 1 ? true : false;
        item.static_template_id = this.templateId || "",
          this.addNewPage(item);
      })
    }
  }

  /**
   * Emit event on clicking exit button
   */
  public exit() {
    this.exitEvent.emit(this.saveTemplateResponse);
  }

  /**
   * Determines whether change language on
   *
   * @param item item
   */
  languageChanged: boolean = false;
  public onChangeLanguage(item) {
    this.selectedLangauge = item; 
    this.languageChanged = true;   
  }

  /**
   * Generates unique id
   * 
   * @returns UniqueId
   */
  generateUniqueId() {
    this.editorCounter += 1;
    return `my_editor${this.editorCounter}`;
  }

  private getFroalaLanguage(): string {
    const appLanguage = (this.translate.currentLang || this.translate.defaultLang || 'en').toLowerCase();
    return this.froalaLanguageMap[appLanguage] || 'en_us';
  }

  /**
   * To add new page
   */
  public addNewPage(staticContent?) {
    this.allowTyping = true;
    const uniqueId = this.generateUniqueId();
    const userId = this.userInfo.userId;
    this.newPages.push({ page_id: '', page_no: this.pageIdCounter++, static_content: '' });
    let newEditorId;
    const lastPageId = `froala${this.newPages.length - 1}`;
    const nextPageId = `froala${this.newPages.length + 1}`;
    if (this.editorIds.length && this.editorIds.includes(lastPageId)) {
      newEditorId = nextPageId;
    } else {
      newEditorId = lastPageId;
    }
    this.editorIds.push(newEditorId);
    setTimeout(() => {
      const editor = new FroalaEditor(`#${newEditorId}`, 
      { key: Froala_Constants.LICENSE_KEY,
        language: this.getFroalaLanguage(),
        fontFamilyDefaultSelection: 'var(--font-NeueHaasDisplayLight)',
        fontFamily: {
          'Neue Haas Display Light': 'var(--font-NeueHaasDisplayLight)',
        },
        fontSizeDefaultSelection: '12',
        charCounterCount: false,
        placeholderText: this.translate.instant('create_your_template_here'),
        imageUpload: true,
        imageDefaultAlign: 'left',
        imageDefaultDisplay: 'inline-block',
        // Set max image size to 5MB.
        imageMaxSize: 5 * 1024 * 1024,
        // Allow to upload PNG and JPG.
        imageAllowedTypes: ['jpeg', 'jpg', 'png'],
        imageUploadParam: 'image_param',
        // Set the image upload URL.
        imageUploadURL: urlPathConstants.imageUploadUrl,
        // Set request type.
        imageUploadMethod: 'POST',
        toolbarButtons: {
          moreText: {
            buttons: ['bold', 'italic', 'underline', 'textColor', 'specialCharacters', 'subscript', 'superscript', 'strikeThrough', 'fontSize', 'backgroundColor'],
            buttonsVisible: 5
          },
          moreParagraph: {
            buttons: ['alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'paragraphFormat', 'outdent', 'indent', 'lineHeight'],
            buttonsVisible: 5
          },
          moreRich: {
            buttons: ['insertLink', 'insertImage', 'insertVideo', 'insertTable'],
            buttonsVisible: 5
          },
          moreMisc: {
            buttons: ['undo', 'redo', 'fullscreen'],
            align: 'right',
            buttonsVisible: 2
          }
        },
        colorsStep: 6,
        colorsText: [
          '#000000', '#ffffff','#00377B', '#06B5CD','#61C0CE', '#C2D0D7'
        ],
        colorsBackground: [
          '#000000', '#ffffff','#00377B', '#06B5CD','#61C0CE', '#C2D0D7', 'REMOVE',
        ],
        tableStyles: {
          noborder: 'Remove Border',
          addborder: 'Add Border',
          dashedborder: 'Dashed Border'
        },
        tableCellMultipleStyles: false,
        listAdvancedTypes: false,
        events: {
          'commands.before': function(command: string, commandValue?: string) {
            if (['tableStyle', 'tableCellStyle', 'tableCellVerticalAlign'].includes(command)) {
              rememberCurrentFroalaTableCells(this);
            }
            if (command === 'indent' || command === 'outdent') {
              const listIndentResult = handleFroalaListIndentCommand(this, command);

              if (listIndentResult.handled) {
                if (listIndentResult.changed) {
                  this.events?.trigger?.('contentChanged');
                }

                return false;
              }
            }

            if (command === 'tableStyle' && ['noborder', 'addborder', 'dashedborder'].includes(commandValue || '')) {
              const didApplyBorder = applyFroalaTableBorderStyleToSelection(this, commandValue);

              if (didApplyBorder) {
                this.events?.trigger?.('contentChanged');
                return false;
              }
            }

            if (command === 'tableCellStyle' && ['fr-highlighted', 'fr-thick'].includes(commandValue || '')) {
              const didApplyCellStyle = applyFroalaTableCellStyleToSelection(this, commandValue);

              if (didApplyCellStyle) {
                this.events?.trigger?.('contentChanged');
                return false;
              }
            }

            if (command === 'tableCellVerticalAlign' && ['top', 'middle', 'bottom'].includes(commandValue || '')) {
              const didApplyVerticalAlign = applyFroalaTableVerticalAlignToSelection(this, commandValue);

              if (didApplyVerticalAlign) {
                this.events?.trigger?.('contentChanged');
                return false;
              }
            }

          },
          'commands.mousedown': function() {
            rememberCurrentFroalaTableCells(this);
          },
          'mousedown': function(event: Event) {
            handleFroalaTableMouseDown(this, event);
          },
          'popups.show.table.edit': function() {
            rememberCurrentFroalaTableCells(this);
            normalizeFroalaTableVerticalAlignCells(this);
          },
          'image.beforeUpload': function (images) {
            if (images.length) {
              const image = images[0];
              this.imageName = image.name;
              this.imageSize = image.size;
              this.imageType = image.type;
              // Get the editor instance
              const editorInstance = this;
              // Set image upload parameters dynamically
              editorInstance.opts.imageUploadParams = {
                static_template_img_id: 0,
                file_name: image.name,
                temp_id: uniqueId,
                page_no: 1,
                file_size: image.size,
                created_by: userId,
                is_active: true,
              };
              console.log('Image Name:', image.name);
              console.log('Image Size:', image.size);
              console.log('Image Type:', image.type);
              // Check if the image size exceeds the limit
              if (image.size > 5 * 1024 * 1024) { // 5MB
                alert('Image size exceeds the allowed limit of 5MB.');
                return false; // Cancel the upload
              }
              // Check if the image type is allowed
              if (!['image/jpeg', 'image/jpg', 'image/png'].includes(image.type)) {
                alert('Invalid image type. Only JPEG and PNG are allowed.');
                return false; // Cancel the upload
              }
            }
          },
          'image.uploaded': function (response) {
            console.log('image.uploaded', response);
            // Image was uploaded to the server.
          },
          'image.inserted': function ($img, response) {
            console.log('image.inserted', $img, response);
            // Image was inserted in the editor.
          },
          'image.replaced': function ($img, response) {
            console.log('image.replaced', $img, response);
            // Image was replaced in the editor.
          },
          'image.error': function (error, response) {
            // Bad link.
            if (error.code == 1) { console.log('Bad link.'); }
            // No link in upload response.
            else if (error.code == 2) { console.log('No link in upload response.'); }
            // Error during image upload.
            else if (error.code == 3) { console.log('Error during image upload.'); }
            // Parsing response failed.
            else if (error.code == 4) { console.log('Parsing response failed.'); }
            // Image too text-large.
            else if (error.code == 5) { console.log('Image too text-large.'); }
            // Invalid image type.
            else if (error.code == 6) { console.log('Invalid image type.'); }
            // Image can be uploaded only to same domain in IE 8 and IE 9.
            else if (error.code == 7) { console.log('Image can be uploaded only to same domain in IE 8 and IE 9.'); }
          },
          contentChanged: () => {
            if (editor && editor.html.get().trim() !== '') {
              this.hasEditorContent = true;
            } else {
              this.hasEditorContent = false;
            }
          
            if (this.editorContent?.length == 0){
              this.editorContent.push(new EditorListDetails(editor.html.get(), newEditorId)); //= editor.html.get();
            }else {
              if (this.editorContent?.filter(it => it.editorId == newEditorId).length == 0)
                this.editorContent.push(new EditorListDetails(editor.html.get(), newEditorId));
              else {
                this.currentEditor = this.editorContent?.filter(it => it.editorId == newEditorId)[0];
                this.currentPageNo = this.newPages[this.activePageIndex]?.page_no
                this.currentEditor.content = editor.html.get();
                if (staticContent) {
                  this.currentEditor.static_template_pages_id = staticContent.static_template_pages_id
                  this.currentPageNo = this.newPages[this.activePageIndex]?.page_no
                  const content = this.currentEditor?.content
                  //this.saveTemplate(this.currentPageNo, content)
                }
              }
            }
            this.checkContentSize();
            this.applyCustomFontToPastedContent(this.pageEditorId);
          },
          initialized: () => {
            bindFroalaTableSelectionHandlers(editor);
            bindFroalaListIndentFix(editor);

            if (!staticContent) editor.events.focus();
            if (staticContent?.static_content) {
              // ToDo: For now comment the code because in some cases page_no could not be match in server and client side
              // this.newPages.forEach(page => {
              //   if (page.page_no == staticContent.page_no) {
              //     editor.html.set(staticContent?.static_content)
              //   }
              // })
        
              const content = this.changeFontFamily(staticContent?.static_content);
              editor.html.set(content)
              normalizeFroalaTableVerticalAlignCells(editor);
              this.newPages.filter(el => el.page_no == staticContent.page_no).map(item => {
                item.page_id = staticContent.static_template_pages_id;
                item.static_content = content;
              })
              this.editorContent.push(new EditorListDetails(content, newEditorId, staticContent.static_template_pages_id))
            } else {
              this.editorContent.push(new EditorListDetails('', newEditorId))
            }
            this.pageEditorId = newEditorId;
            this.setDefaultFont(newEditorId);
            this.applyCustomFontToPastedContent(newEditorId);

            this.setActivePage(this.activePageIndex);
            this.onEditorInitialized();
          },
          'table.inserted': () => {
            console.log('table.inserted');
          },
          'table.removed': () => {
            console.log('table.removed');
          },
          'keydown': (e: KeyboardEvent) =>{
            const listBackspaceResult = handleFroalaListBackspace(editor, e);

            if (listBackspaceResult.handled) {
              if (listBackspaceResult.changed) {
                editor.events?.trigger?.('contentChanged');
              }

              return false;
            }

            this.onKeyDown(e);
            this.applyCustomFontToPastedContent(newEditorId);
          },
          'paste.after': () => {
            this.checkContentSize();
            this.applyCustomFontToPastedContent(this.pageEditorId);
          } 
        },
      });
      if (!staticContent && !this.currentEditor) {
        let previousIndex = this.activePageIndex - 1
        let previousIndexPage = this.editorContent[previousIndex]
        if (previousIndexPage?.content) {
          this.currentPageNo = this.newPages[previousIndex]?.page_no;
          this.currentEditor.content = previousIndexPage?.content;
          this.currentEditor.static_template_pages_id = previousIndexPage?.static_template_pages_id || ''
          this.saveTemplate(this.currentPageNo, this.currentEditor?.content)
        }
      } else {
        if (this.currentEditor?.content) {
          this.saveTemplate(this.currentPageNo, this.currentEditor?.content)
        }
      }
      this.editorInstances[newEditorId] = editor;
      // Store the new editor instance
      this.froalaEditors.push(editor);
    }, 100);
    this.setActivePage(this.newPages.length - 1);
  }

  canRemovePage(): boolean {
    return this.newPages.length > 1;
  }

  public async removePageConfirmation(index) {
    const itemName = this.translate.instant('page').toLowerCase(); 
    const title = this.translate.instant('Are_you_sure_you_want_to_delete')+ ' ' + itemName + '?';
    const actionText = this.translate.instant('Delete');
    const props = {
      confirmationTitle: title,
      actionText
    };
    const modal = await this.modalController.create({
      component: ConfirmationModalComponent,
      cssClass: 'small-alert-modal',
      backdropDismiss: false,
      showBackdrop: false,
      componentProps: props,
    });
    await modal.present();
    const { data: { isActionConfirmed } } = await modal.onWillDismiss();
    if (isActionConfirmed) {
      this.removePage(index);
    }
  }

  /**
   * To remove selected page
   *
   * @param index
   */
  public removePage(index: number) {
    if (this.canRemovePage()) {
      //this.savePageContent(index);
      const pageNo = this.newPages[index]?.page_no
      this.newPages.splice(index, 1);
      this.froalaEditors.splice(index, 1);
      this.editorIds.splice(index, 1);
      this.editorContent.splice(index,1);
      this.setActivePage(Math.min(index, this.newPages.length - 1));
      const content = this.editorContent[index]?.content
      const static_template_pages_id = this.editorContent[index]?.static_template_pages_id
      this.isActive = false;
      // if (content) {
        this.saveTemplate(pageNo, content, static_template_pages_id);
      // }      
      this.newPages.forEach((page, i) => page.page_no = i + 1);
    }
  }

  /**
   * Set active page
   * @param index
   */
  public setActivePage(index: number) {
    this.activePageIndex = index;
    this.froalaEditors.forEach((editor, i) => {
      if (i === index) {
        editor.$box.show();
      } else {
        editor.$box.hide();
      }
    });
  // if (this.currentEditor?.content) {
  //   console.log("updated", this.currentPageNo, this.currentEditor?.content, this.currentEditor?.static_template_pages_id)
  //   //this.saveTemplate(this.currentPageNo, this.currentEditor?.content, this.currentEditor?.static_template_pages_id)
  // }

  }

  /**
   * Generate payload for creating template
   */
  private generatePayload() {
    let payload = {
        id: this.templateId || "",
        type: 3,
        template_type: 1,
        file_name: this.templateName,
        language: this.selectedLangauge,
        created_by: this.userInfo.userId,
        is_active: true,
        is_new_template: false,
        page_list: []
    };    
    
    if (this.editorContent.length > 0) {
        let activeEditorContent = this.editorContent[this.activePageIndex];       
        
        let pageObj = {
            static_template_pages_id: activeEditorContent?.static_template_pages_id || "",
            static_template_id: this.templateId || "",
            page_no: this.activePageIndex + 1,
            static_content: activeEditorContent?.content,
            created_by: this.userInfo.userId,
            is_active: true
        };
        payload.page_list.push(pageObj);
    }
    return payload;
}

  /**
   * Save template
   */
  public saveTemplate(pageNo?, content?, static_template_pages_id?) {
    // This is the case when saveTemplate invoke onSubmit
    this.applyCustomFontToPastedContent(this.pageEditorId);
    if(!pageNo && !content) {
      pageNo = this.activePageIndex != 0 ? this.newPages[this.activePageIndex]?.page_no : 1;
      content = this.editorContent[this.activePageIndex]?.content
      static_template_pages_id = this.editorContent[this.activePageIndex]?.static_template_pages_id
    }
    
    const payload = {
      id: this.templateId,
      type: 3,
      template_type: this.title == 'RA Static Report Templates' ? 1 : this.title == 'Quote Templates' ? 2 : '',
      file_name: this.templateName,
      language: this.languages.find(it => it.label === this.selectedLangauge || it.value === this.selectedLangauge)?.value || this.selectedLangauge,
      created_by: this.userInfo?.userId,
      is_active: true,
      is_new_template: false,
      page_list:  [{
        static_template_pages_id: static_template_pages_id || '',
        static_template_id: this.templateId,
        page_no: pageNo,
        static_content: content,
        created_by: this.userInfo?.userId,
        is_active: this.isActive
      }]
    };
    this.backendService.saveTemplate(payload).subscribe((data: any) => {
      if (data.statusCode == 409) {
        const conflictMessage = data?.message?.toLowerCase?.().trim();
        const toastMessage = conflictMessage === 'file name already exists'
          ? 'File name already exists'
          : data?.message;
        this.toastService.presentToast(toastMessage, 4000, AppConstants.ERROR_SNACKBAR, 'top');
      } else if(data.statusCode == 200) {
        if(data.message !== 'Static Page Deleted'){
          this.templateId = data.response.id;
          this.saveTemplateResponse = data?.response;
          data.response.page_list?.forEach((element, index) => {
            this.editorContent[element.page_no-1].static_template_pages_id = element.static_template_pages_id;
            this.newPages[element.page_no-1].static_content = element.static_content;
            this.newPages[element.page_no-1].page_id =element.static_template_pages_id;
          });
        }
        console.log('saving aaasss')
      }
        // this.templateId = data.response.id;
        // this.saveTemplateResponse = data?.response;
        // data.response.page_list?.forEach((element, index) => {
        //   this.editorContent[element.page_no-1].static_template_pages_id = element.static_template_pages_id;
        //   this.newPages[element.page_no-1].static_content = element.static_content;
        //   this.newPages[element.page_no-1].page_id =element.static_template_pages_id;
        // });
        // }
    });
  }

  /**
   * Checks content size
   */
  private checkContentSize() {
    const editorContent = document.querySelector(`#${this.editorIds[this.activePageIndex]} .fr-view`) as HTMLElement;
    const contentHeight = editorContent?.scrollHeight || 0;
    const maxPageHeight = 1122.52; // A4 page height in pixels
    if (contentHeight > maxPageHeight) {
      this.allowTyping = false;
      this.toastService.presentToast(this.translate.instant('content_exceeds_a4_size'), 3000, AppConstants.WARNING_SNACKBAR, 'top');
      document.querySelector(`#${this.editorIds[this.activePageIndex]} .fr-element`)?.classList.add('exceed-limit');
    } else {
      this.allowTyping = true;
      document.querySelector(`#${this.editorIds[this.activePageIndex]} .fr-element`)?.classList.remove('exceed-limit');
    }
  }

  /**
   * Determines whether editor initialized on
   */
  private onEditorInitialized() {
    document.querySelector('.fr-view')?.classList.add('fr-wrapper');
    this.applyCustomFontToPastedContent();
  }

  /**
   * Determines whether key down on
   * 
   * @param event 
   */
  private onKeyDown(event: KeyboardEvent) {
    if (!this.allowTyping) {
      this.toastService.presentToast(this.translate.instant('content_exceeds_a4_size'), 3000, AppConstants.WARNING_SNACKBAR, 'top');
      event.preventDefault(); // Prevent typing if size exceeds A4
    }
  }

  /**
   * Applys custom font to pasted content
   * 
   * @param [editorId] 
   */
  private applyCustomFontToPastedContent(editorId?) {
    setTimeout(() => {
      const editorContent = document.querySelector(`#${editorId} .fr-view`) as HTMLElement;

      if (editorContent) {
        // Apply the custom font to all pasted content
        const pastedElements = editorContent.querySelectorAll('p, span, div');
        console.log(this.currentEditor, 'this.currentEditor?.content');
        pastedElements.forEach((element: HTMLElement) => {
          element.style.fontFamily = 'var(--font-NeueHaasDisplayLight)';
        });
      }
    }, 1000);
  }

  /**
   * Sets default font
   * 
   * @param editorId 
   */
  private setDefaultFont(editorId: string) {
    const editorContent = document.querySelector(`#${editorId} .fr-view`) as HTMLElement;
    if (editorContent) {
      editorContent.style.fontFamily = 'var(--font-NeueHaasDisplayLight)';
    }
  }

  /**
   * Changes font family
   * 
   * @param content 
   * @returns font family 
   */
  private changeFontFamily(content: string): string {
    // Replace existing font-family with CSS variable
    const updatedContent = content.replace(/font-family:[^;"]+;/g, 'font-family: var(--font-NeueHaasDisplayLight);');
    return updatedContent;
  }

  public drop(event: CdkDragDrop<any[]>) {
    if (event.previousIndex !== event.currentIndex) {
      moveItemInArray(this.newPages, event.previousIndex, event.currentIndex);
      // Reassign page numbers based on new order      
      this.newPages.forEach((page, index) => {
        page.page_no = index + 1;
        this.froalaEditors.forEach((editor, i) => {
          editor.html.set(this.newPages[i].static_content);
          normalizeFroalaTableVerticalAlignCells(editor);
        });
      });       
      this.currentPageNo = this.newPages[event?.currentIndex].page_no;
      this.currentEditor = this.editorContent[event?.currentIndex];
      this.currentEditor.content = this.newPages[event?.currentIndex].static_content;
      this.currentEditor.static_template_pages_id = this.newPages[event?.currentIndex].page_id;
      this.setActivePage(event?.currentIndex)  
      this.cdr.detectChanges();
      
      // ToDo: Call api with updated data
      this.newPages.forEach(page => {
        const { page_no, static_content, page_id } = page;
        this.saveTemplate(page_no, static_content, page_id);
      });
    }
  }
  
  
}